<template>
  <div class="x-misscenlist-box">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column label="用户名">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.username }}( {{scope.row.phone}} )</span>
        </template>
      </el-table-column>

      <el-table-column label="留言时间">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>

      <el-table-column label="留言内容">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.content }}</span>
        </template>
      </el-table-column>

    </el-table>
  </div>


</template>
<script>
import axios from 'axios';
export default {
  name: "wenjuan",
  data(){
    return{
      tableData:[]
    }
  },
  created(){
    this.getdata()
  },
  methods:{
    getdata:function(){
      axios.get('/admin/config/feedback', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.tableData = response.data.list;//部门列表数据
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
  }
}
</script>
<style>
.x-misscenlist-box .el-table th.is-leaf{
  text-align: center;
}.x-misscenlist-box .el-table thead tr th{
  background-color: #F2F2F2;
}.x-misscenlist-box .el-table td{
  text-align: center;
}.x-misscenlist-box .el-tabs__nav-wrap::after{
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/wenjuan.vue